export const marketPresales: { [key: string]: string } = {
  albany: 'https://app.viralsweep.com/sweeps/full/cf05bb-150432?framed=1',
  charlotte: 'https://app.viralsweep.com/sweeps/full/4df64a-150433?framed=1',
  columbus: '',
  minneapolis: 'https://app.viralsweep.com/sweeps/full/5b371d-150435?framed=1',
  fairfield: 'https://app.viralsweep.com/sweeps/full/49608d-150436?framed=1',
  dallas: '',
  baltimore: 'https://app.viralsweep.com/sweeps/full/8a11d4-150439?framed=1',
  denver: 'https://app.viralsweep.com/sweeps/full/43179c-150440?framed=1',
  seattle: 'https://app.viralsweep.com/sweeps/full/52a987-150442?framed=1',
  louisville: 'https://app.viralsweep.com/sweeps/full/ac5cd4-150437?framed=1',
  'salt-lake-city': '',
  boston: 'https://app.viralsweep.com/sweeps/full/65da9e-150438?framed=1',
  'washington-dc': '',
  'long-island': '',
  philadelphia: 'https://app.viralsweep.com/sweeps/full/28c605-150434?framed=1',
  atlanta: '',
  'san-jose': '',
  'colorado-springs': '',
  'san-diego': 'https://app.viralsweep.com/sweeps/full/ebad4c-150441?framed=1',
  quarterfinals: '',
  semifinals: '',
  championship: '',
}

//Market pages
export const marketSlugs = [
  'albany',
  'charlotte',
  'columbus',
  'minneapolis',
  'fairfield',
  'dallas',
  'baltimore',
  'denver',
  'seattle',
  'salt-lake-city',
  'boston',
  'washington-dc',
  'long-island',
  'philadelphia',
  'atlanta',
  'kansas-city',
  'chicago',
  'san-jose',
  'colorado-springs',
  'san-diego',
  'quarterfinals',
  'semifinals',
  'championship',
]

export const homecomingWeekends: { [key: string]: string } = {
  albany: 'ATL',
  charlotte: 'CHA',
  baltimore: 'WHP',
  denver: 'OUT',
  'salt-lake-city': 'ARC',
  boston: 'BOS',
  philadelphia: 'WAT',
  'san-diego': 'RED',
}

export const playoffLocationMap: { [key: string]: string } = {
  quarterfinals: '',
  semifinals: '',
  championship: '',
}
